import axios from 'axios';
import { URLS } from '@constants/urls';
import api from '@helpers/api';
import { encodeQuery } from '@pentabd/ui';

export const getDashboardSummary = (() => {
  const cancelToken = axios.CancelToken;
  let source = cancelToken.source();
  let isRequestInProcess = false;

  return async (
    election_schedule_id: string | number,
  ): Promise<{ data: any }> => {
    if (isRequestInProcess) {
      source.cancel();
      source = cancelToken.source();
    }

    isRequestInProcess = true;

    return api
      .get(encodeQuery(URLS.GET_DASHBOARD_SUMMARY, { election_schedule_id }))
      .then((response) => {
        return { data: response.data };
      })
      .finally(() => {
        isRequestInProcess = false;
      });
  };
})();
